



































































import { Component, Prop, Vue } from "vue-property-decorator";
import { 
  MailCallbackRequestForUserPrompt, 
  SalesOrderPaymentCallbackParams, 
  SalesOrderPaymentValidationResults 
} from "@/dto/mail/callback/MailCallback";
import MailCallbackService from "@/services/MailCallbackService";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";

@Component
export default class SalesOrderPaymentMailCallback extends Vue {
  @Prop({ required: true }) token!: string;
  @Prop({ required: true }) requestData!: MailCallbackRequestForUserPrompt;

  get params(): SalesOrderPaymentCallbackParams {
    return this.requestData.params;
  }

  get validationResults(): SalesOrderPaymentValidationResults {
    return this.requestData.validationResults;
  }

  get isPaid(): boolean {
    return this.validationResults.isPaid || this.params.status === 'ALREADY_PAID';
  }

  get priceIsActual(): boolean {
    return this.validationResults.priceIsActual !== false;
  }

  get displayItems() {
    return (!this.priceIsActual && this.validationResults.actualItems) 
      ? this.validationResults.actualItems 
      : this.params.items;
  }

  get currentSubtotal(): number {
    return !this.priceIsActual && this.validationResults.actualSubtotal !== undefined
      ? this.validationResults.actualSubtotal
      : (this.params.subtotal || 0);
  }

  get currentTax(): number {
    return !this.priceIsActual && this.validationResults.actualTaxAmount !== undefined
      ? this.validationResults.actualTaxAmount
      : (this.params.taxAmount || 0);
  }

  get currentTotal(): number {
    return !this.priceIsActual && this.validationResults.actualTotalAmount !== undefined
      ? this.validationResults.actualTotalAmount
      : this.params.totalAmount;
  }

  get actualTotalAmount(): number {
    return this.validationResults.actualTotalAmount || this.params.totalAmount;
  }

  formatCurrency(cents: number, currency: string): string {
    const symbol = currency === 'USD' ? '$' : currency + ' ';
    return `${symbol}${(cents / 100).toFixed(2)}`;
  }

  formatDate(dateStr: string): string {
    return moment(dateStr).format("MMM DD, YYYY");
  }

  async acceptAndPay() {
    if (this.validationResults.payPalOrderLink && this.priceIsActual) {
      this.$emit('success', this.validationResults.payPalOrderLink);
      return;
    }

    this.$loadOn();
    try {
      const response = await MailCallbackService.runCallbackAction(this.token, {
        params: {
          action: "accept",
          totalAmount: this.currentTotal
        }
      });

      const approveLink = response.data.params.approveLink;
      if (approveLink) {
        this.$emit('success', approveLink);
      } else if (response.data.params.status === 'rejected') {
        this.$nts.error("Action was rejected by server.");
      } else {
        this.$nts.error("No payment link received.");
      }
    } catch (e: any) {
      processError(this, e);
    } finally {
      this.$loadOff();
    }
  }
}
